var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleWaves(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 471,
    viewBox: "0 0 509 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7362 519.333C2.40273 477.15 5.41939 387.917 124.154 368.448C272.571 344.112 268.571 279.061 273.821 231.314C279.071 183.567 282.654 36.8361 407.877 60.0176C510.723 77.1961 547.471 28.2331 555.073 3.66675",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.831 521C90.331 482.738 95.0935 402.388 198.144 387.086C326.957 367.959 330.457 308.295 332.395 265.11C334.332 221.925 340.895 99.377 444.812 111.638C531.946 119.397 562.632 83.0497 570.209 67",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.044 522.667C178.377 488.325 184.886 416.858 272.253 405.724C381.461 391.806 392.461 337.53 391.086 298.907C389.712 260.283 399.253 161.918 481.865 163.259C553.287 161.598 577.911 137.866 585.462 130.333",
    stroke: "#6B7B8E",
    strokeWidth: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleWaves);
export default __webpack_public_path__ + "static/media/middle-waves.14b5e1b37c3610f2a56c5aeca0568c8a.svg";
export { ForwardRef as ReactComponent };